export { default as AvatarInitials } from './Initials';
export { default as AvatarIcon } from './Icon';

export enum AvatarSize {
  XSmall,
  Small,
  Normal,
  Large,
}
